import { Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomEventDispatcherService {
  listenEvent<T = void>(eventName: string): Observable<T> {
    return fromEvent<CustomEvent<T>>(window, eventName).pipe(map(event => event.detail));
  }
}
